import React, { useState } from "react";

import { CodeRequestCard, EnterCodeCard } from "./HubCard";
import HubPageWrapper from "./HubPageWrapper";
import { HubSurveysCard, NoSurveysCard } from "./HubSurveysCard";

function HubPage() {
    const [displayLogin, setDisplayLogin] = useState(true);
    const [displayCodeCheck, setDisplayCodeCheck] = useState(false);
    const [contactInfo, setContactInfo] = useState("");
    const [{ companyName, firstName, surveyList }, setPageData] = useState({
        company: "",
        firstName: "",
        surveyList: [],
    });
    const surveyListEmpty = surveyList.length === 0;

    return (
        <HubPageWrapper legalText={null} companyName={companyName}>
            {displayLogin && (
                <CodeRequestCard
                    setVisible={setDisplayLogin}
                    setContactInfo={setContactInfo}
                    showDisplayCode={setDisplayCodeCheck}
                />
            )}
            {!displayLogin && displayCodeCheck && (
                <EnterCodeCard
                    contactInfo={contactInfo}
                    setVisible={setDisplayCodeCheck}
                    setLoginVisible={setDisplayLogin}
                    setPageData={setPageData}
                />
            )}
            {!displayLogin && !displayCodeCheck && (
                <>
                    {surveyListEmpty && <NoSurveysCard companyName={companyName} />}
                    {!surveyListEmpty && (
                        <HubSurveysCard firstName={firstName} surveyList={surveyList} />
                    )}
                </>
            )}
        </HubPageWrapper>
    );
}

export default React.memo(HubPage);
